import React, { useState } from "react";
import { Card, Title } from "@mantine/core";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

import { ProfileForm, ProfileList } from "./";
import { ManagementLayout, Can } from "@components/shared";
import { PERMISSIONS } from "@util/permissions";

export default function ProfileManagement() {
  const [refresh, setRefresh] = useState(false);
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <ManagementLayout
      dataComponent={<ProfileList refresh={refresh} />}
      createComponent={
        <Can permission={PERMISSIONS.OCCUPATIONAL_PROFILES_CREATE}>
          <Card>
            <Title order={4}>
              {t("create")} {t("cs:profile_singular")}
            </Title>
            <ProfileForm
              onSuccess={(profile) => {
                setRefresh(!refresh);
                if (profile?.id) navigate(`/profiles/${profile.id}`);
              }}
            />
          </Card>
        </Can>
      }
    />
  );
}
